import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Input,
  InputAdornment,
  Tooltip,
  TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { capitalize } from "../../utils/helpers";
import errorHandler from "../../utils/errorHandler";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Helmet } from "react-helmet-async";
import ApiService from "../../services/categoryManagementApi";
import TableFilter from "../../components/shared/TableFilter";
import CustomLoader from "../../components/customLoader";
import moment from "moment";
import { QUERY_OPTIONS } from "../../utils/constants";

const { customerQueryApi } = ApiService;

export default function CustomerQueryManagement() {
  const navigate = useNavigate();

  const [searchItem, setSearchItem] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const today = new Date().toISOString().split("T")[0]; 
const fromDateValue = fromDate?.slice(0, 10);

  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
      sortable: false,
    },
    {
      name: "Name",
      sortable: true,
      selector: (row) => capitalize(row.name),
    },
    {
      name: "Email",
      sortable: true,
      selector: (row) => row.email,
    },
    {
      name: "Date",
      sortable: true,
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
    },
    {
      name: "Query Status",
      sortable: true,
      selector: (row) => row?.queryStatus,
    },
    {
      name: "Action",
      right: true,
      cell: (row) => (
        <Box display="flex" justifyContent="center" width="100%">
        <Tooltip title="View" placement="top">
          <IconButton
            color="primary"
            onClick={() => navigate(`/customer-query-management/view/${row?._id}`)}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      </Box>
      ),
    },
  ];

  const fetchCustomerData = () => {
    const body = {
      searchItem: searchItem.trim() || "",
      pageNumber: currentPage,
      pageSize: pageSize,
      status: status.length ? status : undefined,
      startDate: fromDate,
      endDate: toDate,
    };

    customerQueryApi
      .getAllSupport(body)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.data?.result || []);
          setTotalRecords(res?.data?.data?.totalRecords || 0);
        }
      })
      .catch(errorHandler)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    fetchCustomerData();
  }, [searchItem, currentPage, pageSize, refresh, status, fromDate, toDate]);
  

  return (
    <Card>
      <Helmet>
        <title>Customer Query Management</title>
      </Helmet>
      <CardHeader title="Customer Query Management" titleTypographyProps={{ variant: "h4" }} />
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        
          <TextField
            label="From Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: today,
            }}
            size="small"
            sx={{ marginRight: 2 }}
            value={fromDateValue}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                setFromDate(`${value}T00:00:00.000Z`);
                if (toDate && new Date(value) > new Date(toDate)) {
                  setToDate("");
                }
              } else {
                setFromDate(""); 
              }
            }}
          />


          <TextField
            label="To Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: today,
              min: fromDateValue || undefined,
            }}
            size="small"
          sx={{ marginRight: 2 }}
            value={toDate ? toDate.slice(0, 10) : ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                setToDate(`${value}T00:00:00.000Z`);;
              } else {
                setToDate(""); 
              }
            }}
          />


          {/* Status Filter */}
          <TableFilter data={QUERY_OPTIONS} value={status} setValue={setStatus} filterName="Status" />

          {/* Search Box */}
          <Input
            placeholder="Search"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value.trimStart())}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setSearchItem("")}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>

        <DataTable
          customStyles={{
            headCells: { style: { fontSize: "15px", fontWeight: "bold" } },
          }}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalRecords}
          onChangePage={(page) => setCurrentPage(page)}
          paginationPerPage={pageSize}
          onChangeRowsPerPage={(currentRowsPerPage) => {
            setPageSize(currentRowsPerPage);
            setCurrentPage(1);
          }}
          progressPending={loading}
          progressComponent={<CustomLoader />}
        />
      </CardContent>
    </Card>
  );
}
